import {Component, OnDestroy, OnInit} from '@angular/core';
import { NbThemeService } from '@nebular/theme';
import { takeWhile } from 'rxjs/operators' ;
import { SolarData } from '../../@core/data/solar';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';
import { HttpClient } from '@angular/common/http';
import { EChartOption } from 'echarts';
import { UtilidadesService } from '../../@core/utils/utilidades.service';


interface CardSettings {
  title: string;
  iconClass: string;
  type: string;
}

@Component({
  selector: 'ngx-dashboard',
  styleUrls: ['./dashboard.component.scss'],
  templateUrl: './dashboard.component.html',
})
export class DashboardComponent implements OnDestroy, OnInit {

  private alive = true;
  resultadoRequest:any;
  solarValue: number;
  arrayMeses = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];
  resulActMes:any;
optionMes:EChartOption;
optionAnio: EChartOption;
optionUserAnio;

  actividadesMesCard: CardSettings = {
    title: 'Actividades del mes',
    iconClass: 'fas fa-chalkboard',
    type: 'primary',
  };
  participantesMesCard: CardSettings = {
    title: 'Participantes del mes',
    iconClass: 'fas fa-chalkboard-teacher',
    type: 'success',
  };
  actividadesAñoCard: CardSettings = {
    title: 'Actividades del año',
    iconClass: 'fas fa-chalkboard',
    type: 'info',
  };
  participantesAnioCard: CardSettings = {
    title: 'Participantes del año',
    iconClass: 'fas fa-chalkboard-teacher',
    type: 'info',
  };

  balanceMesMakerCard: CardSettings = {
    title: 'Balance económico mes',
    iconClass: 'fas fa-chart-line',
    type: 'info',
  };

  balanceAnioMakerCard: CardSettings = {
    title: 'Balance económico año',
    iconClass: 'fas fa-chart-line',
    type: 'info',
  };

  statusCards: string;
  statusCardss:any;

  commonStatusCardsSet: CardSettings[] = [
    this.actividadesMesCard,
    this.actividadesAñoCard,
    this.participantesMesCard,
    this.participantesAnioCard,
    this.balanceMesMakerCard,
    this.balanceAnioMakerCard
  ];

  statusCardsByThemes: {
    default: CardSettings[];
    cosmic: CardSettings[];
    corporate: CardSettings[];
  } = {
    default: this.commonStatusCardsSet,
    cosmic: this.commonStatusCardsSet,
    corporate: [
      {
        ...this.actividadesMesCard,
        type: 'primary',
      },
      {
        ...this.actividadesAñoCard,
        type: 'primary',
      },
      {
        ...this.participantesMesCard,
        type: 'success',
      },
      {
        ...this.participantesAnioCard,
        type: 'success',
      },
      {
        ...this.balanceMesMakerCard,
        type: 'warning',
      },
      {
        ...this.balanceAnioMakerCard,
        type: 'warning',
      },
    ],
  };
  httpF: HttpClient;
  export_path: any;
  constructor(private themeService: NbThemeService,
              private solarService: SolarData,private _http : PeticionesHttpBackEndService,http: HttpClient,private utilidades: UtilidadesService) {

    this.themeService.getJsTheme()
      .pipe(takeWhile(() => this.alive))
      .subscribe(theme => {
        this.statusCards = this.statusCardsByThemes[theme.name];
    });


    this.solarService.getSolarData()
      .pipe(takeWhile(() => this.alive))
      .subscribe((data) => {
        this.solarValue = data;
      });
      this.httpF = http;
  }

  ngOnInit(){
    $(".menu-sidebar").show();

    this._http.getGenerico("v1/datosGraficas").subscribe(
      result => {
        this.resulActMes = result;
        this.cargarGrafInfMes(this.resulActMes);
        this.cargarGrafInfAnio(this.resulActMes);
        this.cargarGrafNumUser(this.resulActMes);
        },
      error => {
        //this.utilidades.notificationWarning("Aviso","Error intentando cargar los graficos","top-left");
      }
    );
  }
  cargarGrafInfMes(result){
    let gastosMes: number = parseFloat(result.gastosMes[0].GastosMes);
    let ingresosMes: number = parseFloat(result.ingresosMes[0].IngresosMes);
    let balanceMes: number = parseFloat(result.balanceMes[0].BalanceMes);
        this.optionMes = {
          legend: {},
          tooltip: {},
          dataset: {
              source: [
                  ['product', 'Gastos mes', 'Ingresos mes', 'Balance mes'],
                  [this.arrayMeses[new Date().getMonth()], gastosMes.toFixed(2), ingresosMes.toFixed(2), balanceMes.toFixed(2)],
              ]
          },
          xAxis: {type: 'category'},
          yAxis: {},
          // Declare several bar series, each will be mapped
          // to a column of dataset.source by default.
          series: [
              {type: 'bar'},
              {type: 'bar'},
              {type: 'bar'}
          ]
      };
  }
  cargarGrafInfAnio(result){
    let gastosAnio: number = parseFloat(result.gastosAnio[0].GastosAnio);
    let ingresosAnio: number = parseFloat(result.ingresosAnio[0].IngresosAnio);
    let balanceAnio: number = parseFloat(result.balancesAnios[0].BalanceAnio);
    this.optionAnio = {
      legend: {},
      tooltip: {},
      dataset: {
          source: [
              ['product', 'Gastos año', 'Ingresos año', 'Balance año'],
              [new Date().getFullYear(), gastosAnio.toFixed(2), ingresosAnio.toFixed(2), balanceAnio.toFixed(2)],
          ]
      },
      xAxis: {type: 'category'},
      yAxis: {},
      // Declare several bar series, each will be mapped
      // to a column of dataset.source by default.
      series: [
          {type: 'bar'},
          {type: 'bar'},
          {type: 'bar'}
      ]
    };

  }

  cargarGrafNumUser(result){
      this.optionUserAnio = {

        tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
            name: '',
            bottom: 1,
            left: 'center',
            
            data:[
              {value: result.apuntadosMes[0].NumApuntadosMes, name:this.arrayMeses[new Date().getMonth()]},
              {value: result.apuntadosAnio[0].NumApuntadosAnio, name:new Date().getFullYear()},
              
          ]
        },
        series : [
            {
                type: 'pie',
                name: 'Usuarios',
                radius : '75%',
                center: ['50%', '50%'],
                data:[
                  {value: result.apuntadosMes[0].NumApuntadosMes, name:this.arrayMeses[new Date().getMonth()]},
                  {value: result.apuntadosAnio[0].NumApuntadosAnio, name:new Date().getFullYear()},
                  
              ],
                itemStyle: {
                    emphasis: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }
        ]
      };
  }
  ngOnDestroy() {
    this.alive = false;
  }
  generarInforme() {
    
    this._http.DownloadFileExcel("v1/generarInforme",{}).subscribe(
      result => {
        this.resultadoRequest = result;
        const linkSource = 'data:'+'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'+';base64,' + this.resultadoRequest.Archivo;
        const downloadLink = document.createElement("a");
        const fileName = this.resultadoRequest.NombreArchivo;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      },
      error => {
        //this.utilidades.notificationWarning("Aviso","Error al descargar el informe","top-left");
      }
    );
  }
 
}
